var button = document.getElementById( 'history-button' );

if ( button ) {
  button.addEventListener( 'click', function( e ) {
    window.history.go( -1 );
  }, false );
}
